'use client';

import { Button, Padding, Typography } from '@musinsa/mds';
import { useFormContext } from 'react-hook-form';
import { BottomButtonWrapper } from '../../common/components/BottomButtonWrapper';
import type { SNSLinkEditFormData } from './SNSLinkEditForm';

interface SubmitButtonProps {
  isLoading: boolean;
}

export const SubmitButton = ({ isLoading }: SubmitButtonProps) => {
  const {
    watch,
    formState: { isDirty, errors },
  } = useFormContext<SNSLinkEditFormData>();

  const watchedSnsLinks = watch('snsLinks');

  // URL 유효성 검사 함수
  const isValidUrl = (url: string): boolean => {
    const urlPattern = /^https?:\/\/[^\s]+\.[^\s]{2,}(\/[^\s]*)?$/i;
    return urlPattern.test(url);
  };

  // Submit disabled 조건 검사 (early return 패턴)
  const getSubmitDisabled = (): boolean => {
    // 1. isDirty 상태가 아니면 inactive
    if (!isDirty) {
      return true;
    }

    // 2. URL이 하나라도 입력되지 않으면 inactive (우선조건)
    if (watchedSnsLinks.some((link) => !link.url || link.url === '')) {
      return true;
    }

    // 3. ETC 플랫폼의 경우 온전한 URL 형태 검사
    if (
      watchedSnsLinks.some((link) => link.platform === 'ETC' && link.url && !isValidUrl(link.url))
    ) {
      return true;
    }

    // 4. 에러가 있으면 inactive (검증 중 상태 포함)
    if (Object.keys(errors).length > 0) {
      return true;
    }

    return false;
  };

  return (
    <BottomButtonWrapper>
      <Padding y="3">
        <Button
          size="44"
          className="w-full"
          variant="primary"
          type="submit"
          isLoading={isLoading}
          disabled={getSubmitDisabled()}
        >
          <Typography size="14" weight="medium">
            수정하기
          </Typography>
        </Button>
      </Padding>
    </BottomButtonWrapper>
  );
};
